"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const constants_1 = require("../constants/constants");
const useDesktopDesign = (customBreakpoint = null) => {
    const { width } = react_native_1.useWindowDimensions();
    return width >= (customBreakpoint || constants_1.DESKTOP_BREAKPOINT) && react_native_1.Platform.OS === constants_1.WEB_TAG;
};
exports.default = useDesktopDesign;
